export const filterAmenitiesByName = <T extends { name?: string }>(items: T[], query: string) => {
  const normalized = query.trim().toLowerCase()

  if (!normalized) return items

  return items.filter((item) => item.name?.toLowerCase().includes(normalized))
}
